import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const apiServer = axios.create({
    baseURL: apiUrl,
    withCredentials: true
});

export default apiServer;